import { ButtonDefault } from '@/components/common/Button'
import { PriceSource } from '@/components/common/PriceSource'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type CardType } from '@/defs/card'
import { type PriceSourceType } from '@/defs/price'
import { useReduxSelector } from '@/store/hooks'

import styles from './CardFacePricesMore.module.scss'

type Props = {
  card: CardType
  priceSources: PriceSourceType[]
}

export const CardFacePricesMore = ({ card, priceSources }: Props) => {
  const userStatus = useReduxSelector((s) => s.user.status)

  return (
    <div>
      <p className={styles.heading}>More Prices</p>
      <ul className={styles.list}>
        {priceSources.map((priceSource) => (
          <li key={priceSource}>
            <PriceSource card={card} priceSource={priceSource} size='lg' />
          </li>
        ))}
        <li>
          <ButtonDefault
            as='LinkRoute'
            colorScheme='subtle'
            href={userStatus === 'signedIn' ? '/account/#preferences' : '/signin'}
            maxwidth
            size='sm'
          >
            <IconWithLabel iconBefore='wrench' iconBeforeMargin='sm' iconBeforeSize='sm'>
              Manage
            </IconWithLabel>
          </ButtonDefault>
        </li>
      </ul>
    </div>
  )
}
